import React from 'react'

import { useMutation } from '@apollo/client'
import { Button } from '@material-ui/core'

import { UserContext } from '../../App'
import { FOLLOW_USER, UNFOLLOW_USER } from '../../graphql/mutations'
import { useFollowButtonStyles } from '../../styles'

function FollowButton({ id, side }) {
  const classes = useFollowButtonStyles({ side })
  const { currentUserId, followingIds } = React.useContext(UserContext)
  const isAlreadyFollowing = followingIds.some(
    followingId => followingId === id
  )
  const [isFollowing, setIsFollowing] = React.useState(isAlreadyFollowing)
  const [followUser] = useMutation(FOLLOW_USER)
  const [unfollowUser] = useMutation(UNFOLLOW_USER)
  const variables = {
    userIdToFollow: id,
    currentUserId
  }

  function handleFollowUser() {
    setIsFollowing(true)
    followUser({ variables })
  }

  function handleUnfollowUser() {
    setIsFollowing(false)
    unfollowUser({ variables })
  }

  const followButton = (
    <Button
      variant={side ? 'text' : 'contained'}
      color="primary"
      className={classes.button}
      onClick={handleFollowUser}
      fullWidth
    >
      Follow
    </Button>
  )

  const isFollowingButton = (
    <Button
      variant={side ? 'outlined' : 'text'}
      className={classes.button}
      onClick={handleUnfollowUser}
      fullWidth
    >
      Following
    </Button>
  )

  return isFollowing ? isFollowingButton : followButton
}

export default FollowButton
